<template>
  <!-- 整个布局的根容器，管理整体结构 -->
  <div id="layout-container">

    <!--
      移动端顶部导航栏
      仅在手机端（isMobile）显示
    -->
    <div v-if="isMobile" class="mobile-header">
      <!-- 菜单按钮：点击展开侧边栏 -->
      <el-button icon="el-icon-menu" @click="showSidebar = true" circle size="small" />

      <!-- 系统名称 -->
      <span class="system-name">电商运营管理系统</span>

      <!-- 退出登录按钮 -->
      <el-button icon="el-icon-switch-button" @click="confirmLogout" circle size="small" type="danger" />
    </div>

    <!--
      遮罩层
      移动端侧边栏打开时显示，点击关闭侧边栏
    -->
    <div v-if="isMobile && showSidebar" class="mask" @click="showSidebar = false"></div>

    <!-- Element UI 布局容器 -->
    <el-container style="height:100vh">

      <!--
        侧边栏
        PC端：固定显示
        移动端：抽屉式弹出
      -->
      <el-aside
        :width="isMobile ? '200px' : '200px'"
        class="sidebar"
        :class="{ 'sidebar-mobile': isMobile, 'sidebar-open': showSidebar }"
        style="background:#2f4050;display:flex;flex-direction:column"
      >
        <!--
          左侧菜单
          :default-active="$route.path"  根据当前路由自动高亮菜单项
          router  开启路由跳转模式
        -->
        <el-menu
          :default-active="$route.path"
          router
          background-color="#2f4050"
          text-color="#fff"
          active-text-color="#ffd04b"
          style="flex:1"
        >
          <el-menu-item index="/welcome">首页</el-menu-item>
          <el-menu-item index="/user">用户管理</el-menu-item>
          <el-menu-item index="/goods">商品管理</el-menu-item>
          <el-menu-item index="/order">订单管理</el-menu-item>
        </el-menu>

        <!-- 侧边栏底部用户信息区域 -->
        <div style="padding:15px;background:#253342;color:#fff;border-top:1px solid #394a5f">
          <div style="font-size:14px;margin-bottom:8px">用户名：admin</div>
          <div style="font-size:12px;color:#aaa;margin-bottom:10px">{{ nowTime }}</div>

          <!-- PC端显示退出按钮 -->
          <el-button v-if="!isMobile" type="danger" size="mini" style="width:100%" @click="confirmLogout">退出登录</el-button>
        </div>
      </el-aside>

      <!-- 右侧主内容区域 -->
      <el-container>
        <el-main class="main-content">
          <!-- 路由视图：子页面在这里渲染 -->
          <router-view />
        </el-main>
      </el-container>

    </el-container>
  </div>
</template>

<script>
export default {
  // 页面数据定义
  data() {
    return {
      nowTime: '',        // 当前显示的时间
      isMobile: false,    // 是否为移动端
      showSidebar: false  // 移动端侧边栏是否显示
    }
  },

  // 页面挂载完成后执行
  mounted() {
    // 判断是否为手机端
    this.checkMobile()

    // 监听窗口大小变化，自动判断设备
    window.addEventListener('resize', this.checkMobile)

    // 初始化时间
    this.updateTime()

    // 每秒更新一次时间
    this.timer = setInterval(() => this.updateTime(), 1000)
  },

  // 页面销毁前清除定时器与监听
  beforeDestroy() {
    clearInterval(this.timer)
    window.removeEventListener('resize', this.checkMobile)
  },

  // 方法集合
  methods: {
    // 判断是否为移动设备
    checkMobile() {
      this.isMobile = window.innerWidth < 768
      if (!this.isMobile) this.showSidebar = false
    },

    // 更新当前时间
    updateTime() {
      this.nowTime = new Date().toLocaleString()
    },

    // 退出登录确认
    confirmLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'mobile-confirm-dialog'
      }).then(() => {
        // 清除缓存
        sessionStorage.clear()
        // 跳转到登录页
        this.$router.push('/login')
        // 提示信息
        this.$message.success('已退出登录')
      }).catch(() => {
        // 取消退出，不执行操作
      })
    }
  }
}
</script>

<style scoped>
/* 整体布局容器：占满屏幕 */
#layout-container {
  height: 100vh;
  overflow: hidden;
}

/* 移动端顶部导航栏样式 */
.mobile-header {
  display: flex;
  align-items: center;
  background: #2f4050;
  color: white;
  padding: 0 15px;
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
}

/* 系统名称居中 */
.system-name {
  flex: 1;
  text-align: center;
  font-size: 18px;
}

/* 遮罩层样式 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
}

/* 侧边栏样式 */
.sidebar {
  transition: transform 0.3s;
}

/* 移动端侧边栏默认隐藏 */
.sidebar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1001;
  transform: translateX(-100%);
}

/* 侧边栏打开状态 */
.sidebar-open {
  transform: translateX(0);
}

/* 主内容区域 */
.main-content {
  padding: 15px !important;
  margin-top: 0;
}

/* 移动端主内容距离顶部 50px */
@media (max-width: 767px) {
  .main-content {
    padding: 15px !important;
    margin-top: 50px;
  }
}
</style>